
import AuthProtected from 'containers/AuthProtected/AuthProtected';
import React, { useEffect, useState } from 'react';

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import CSSModule from 'react-css-modules';
import { FormattedMessage, injectIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { AppWrapper, Block, Button, Modal, Spinner } from 'components';
import Breadcrumbs from 'components/BreadCrumbs/BreadCrumbs';
import { actions as fetchUsersDataActions } from 'coupon-common/src/modules/admin/userManager/fetchUsersData';

import messages from './messages';
import styles from './UserManager.module.scss';
import { connect } from 'react-redux';

const UserManager = ({
  intl,
  dispatch,
  usersData,
}) => {
  const [isActive, setIsActive] = useState('customers');
  const [searchQuery, setSearchQuery] = useState(null);
  const [mainData, setMainData] = useState(null);
  const [customersData, setCustomerData] = useState([]);
  const [businessesData, setBusinessesData] = useState([]);
  const [updatedPaginationOptions, setUpdatedPaginationOptions] = useState({})

  const navigate = useNavigate();

  useEffect(() => {
    fetchUserDetails();
  }, []);

  useEffect(() => {
    filterData();
  }, [usersData]);

  useEffect(() => {
    if (searchQuery) {
      handleSearch();
    } else {
      filterData();
    }
  }, [searchQuery]);

  const fetchUserDetails = () => {
    // if the data is already present in redux it won't make unnecessary API calls
    if (!usersData?.length) {
      dispatch(fetchUsersDataActions.getAllUsers());
    }
  };

  const filterData = () => {
    if (usersData?.length) {
      const customersDataArray = [];
      const businessesDataArray = [];

      const sortByNewUser =  [...usersData]?.sort((a, b) =>
        new Date(b.signed_at) - new Date(a.signed_at)
    );


      sortByNewUser.map(user => {
        const formattedUser = {
          id: user?.id,
          first_name: user?.first_name || user?.contact_name,
          email: user?.email,
          points: user?.wallet?.points_at_last_date,
          business: user?.name,
          is_business: user?.is_business,
      };

        if (user?.is_business) {
          businessesDataArray.push(formattedUser);
        } else {
          customersDataArray.push(formattedUser);
        }

        return formattedUser;
      });

      setCustomerData(customersDataArray);
      setBusinessesData(businessesDataArray);
      setMainData(
        isActive === 'customers' ? customersDataArray : businessesDataArray,
      );
    }
  };

  const handleChange = value => {
    setIsActive(value);

    if (value == 'businesses') {
      setMainData(businessesData);
    } else if (value == 'customers') {
      setMainData(customersData);
    }
  };

  const handleSearch = () => {
    let result = [];
    const query = searchQuery.trim().toLowerCase();

    if (isActive === 'customers') {
        result = customersData.filter(user => {
            return (
                user?.first_name?.toLowerCase().includes(query) ||
                user?.email?.toLowerCase().includes(query)
            );
        });
    } else if (isActive === 'businesses') {
        result = businessesData.filter(user => {
            return (
              user?.first_name?.toLowerCase().includes(query) ||
                user?.business?.toLowerCase().includes(query) ||
                user?.email?.toLowerCase().includes(query)
            );
        });
    }

    setMainData(result);
};

  const handlePageChange = data => {
    const { id } = data;
    navigate(`/admin/users/${id}`);
  };

  const columns = [
    {
      dataField: 'first_name',
      text: intl.formatMessage(messages.firstNameColumnText),
      sort: true,
    },
    ...(isActive === 'businesses'
      ? [
          {
            dataField: 'business',
            text: intl.formatMessage(messages.businessColumnText),
            sort: true,
          },
        ]
      : []),
    {
      dataField: 'email',
      text: intl.formatMessage(messages.emailColumnText),
      sort: true,
    },
    {
      dataField: 'points',
      text: intl.formatMessage(messages.pointsColumnText),
      sort: true,
    },
    {
      dataField: ' ',
      text: ' ',
      classes: styles['edit'],
      formatter: cellContent =>
        cellContent || intl.formatMessage(messages.editColumnText),
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          handlePageChange(row);
        },
      },
    },
  ];

  const upadteOptions = () => {
      const paginationOptions = {
        sizePerPage: 25,
        totalSize: mainData?.length,
        showTotal: true,
        sizePerPageList: [10, 25, 50, 100],
        firstPageText: 'First',
        lastPageText: 'Last',
        nextPageText: 'Next',
        prePageText: 'Previous',
        withFirstAndLast: true,
      }

      setUpdatedPaginationOptions(paginationOptions);
  }


  useEffect(()=>{
      upadteOptions();
  }, [isActive, businessesData, customersData])

  return (
    <AppWrapper
      showHeader
      showSideNav
      showHeadingRow
      headingText={intl.formatMessage(messages.pageHeadingText)}
    >
      <AuthProtected />

      <div className="col-md-12">
        <Breadcrumbs locationArray={['Admin', 'User Manager']} />
        <Block>
          {mainData == null || mainData == undefined ? (
            <Spinner show />
          ) : (
            <>
              <div className="container">
                <div
                  styleName="row"
                  className="row justify-content-between align-items-center mb-3 p-1"
                >
                  <div styleName="btn-container">
                    <button
                      styleName={`${isActive == 'customers' ? 'active' : ''}`}
                      onClick={() => handleChange('customers')}
                    >
                      <FormattedMessage {...messages.customersColumnText} />
                    </button>
                    <button
                      styleName={`${isActive == 'businesses' ? 'active' : ''}`}
                      onClick={() => handleChange('businesses')}
                    >
                      <FormattedMessage {...messages.businessesColumnText} />
                    </button>
                  </div>
                  <div styleName="search">
                    <input
                      type="text"
                      placeholder="Search"
                      onChange={e => setSearchQuery(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div
                styleName="table-container"
                className="table-container overflow-auto"
              >
                <BootstrapTable
                  classes="table-borderless mb-0 overflow-auto custom-react-bootstrap-table ml-0 mr-0"
                  striped
                  bordered={false}
                  bootstrap4
                  keyField="id"
                  data={mainData}
                  columns={columns}
                  pagination={paginationFactory(updatedPaginationOptions)}
                />
              </div>
            </>
          )}
        </Block>
      </div>
    </AppWrapper>
  );
};

const mapStateToProps = state => {
  return {
    usersData: state.admin.userManager.fetchUsersData.data,
  };
};

export default connect(mapStateToProps)(injectIntl(CSSModule(UserManager, styles)),);